import { Component, Input, OnInit } from '@angular/core';
import { ManagementEntityEventModel } from '@data-layer/models/management';

import { CbpMessageHelper } from '@helpers/cbp-message.helper';

@Component({
  selector: 'cbp-log-message',
  templateUrl: './cbp-log-message.component.html',
  styleUrls: ['./cbp-log-message.component.scss'],
})
export class CbpLogMessageComponent implements OnInit {
  @Input() public message: ManagementEntityEventModel;
  @Input() public sendToProviderDate: string;

  public readonly formatDateTime = 'MM/dd/yyyy HH:mm:ss';
  public open: boolean = false;

  constructor() {}

  public ngOnInit(): void {
    this.open = !this.expired;
  }

  public get expired(): boolean {
    return CbpMessageHelper.expired(this.message.timestamp, this.sendToProviderDate);
  }
}
